import { getBridgeRoot } from '../../files/cwd/index.js';
import { discoverSessionWorktreeOnDisk } from '../discovery/index.js';
import type { WorktreeLayoutFile } from '../worktree-layout-file.js';
import type { SessionWorktreeBinding } from '../session-worktree-binding.js';

const discoverInflightBySessionId = new Map<string, Promise<SessionWorktreeBinding | null>>();

export function discoverSessionBindingAsync(params: {
  sessionId: string;
  worktreesRootPath: string;
  layout: WorktreeLayoutFile;
}): Promise<SessionWorktreeBinding | null> {
  const sid = params.sessionId.trim();
  if (!sid) return Promise.resolve(null);
  const existing = discoverInflightBySessionId.get(sid);
  if (existing) return existing;

  const promise = discoverSessionWorktreeOnDisk({
    sessionId: sid,
    worktreesRootPath: params.worktreesRootPath,
    layout: params.layout,
    bridgeRoot: getBridgeRoot(),
  }).finally(() => {
    if (discoverInflightBySessionId.get(sid) === promise) {
      discoverInflightBySessionId.delete(sid);
    }
  });
  discoverInflightBySessionId.set(sid, promise);
  return promise;
}
